import * as actionTypes from "./FaqsTypes";

const INTIAL_STATE = {
    Faqsdata: null,
    isLoadingFaqs: false,

    isLoadingSaveFaqs: false,
};
const FaqsReducer = (state = INTIAL_STATE, action) => {
    const { payload } = action;
    switch (action.type) {
        case actionTypes.IS_LOADING_FAQS:
            return {
                ...state,
                isLoadingFaqs: true
            };
        case actionTypes.FAQS_DATA_SUCCESS:
            return {
                ...state,
                Faqsdata: payload,
                isLoadingFaqs: false,

            };
        case actionTypes.FAQS_DATA_FAILED:
            return {
                ...state,
                isLoadingFaqs: false
            };
        //////////////////////////////////////////////////////////////////////

        case actionTypes.IS_LOADING_SAVE_FAQS:
            return {
                ...state,
                isLoadingSaveFaqs: true
            };
        case actionTypes.SAVE_FAQS_DATA_SUCCESS:
            return {
                ...state,
                Faqsdata: payload,
                isLoadingSaveFaqs: false
            };
        case actionTypes.SAVE_FAQS_DATA_FAILED:
            return {
                ...state,
                isLoadingSaveFaqs: false
            };



        default:
            return state;
    }
};

export default FaqsReducer;
